export default __webpack_public_path__ + "static/blob5-74f044d4c353da4999a889953dca1270.svg";